import SkapaSelect, {
  type SelectAttributes,
  type SelectProps,
} from "@ingka/select";

export { Option } from "@ingka/select";

export const Select = (props: SelectProps & SelectAttributes) => {
  return (
    <SkapaSelect
      prefix="saleslead__"
      // hintText={t("action.choose_an_option")}
      {...props}
    />
  );
};
